import { useEffect, useMemo } from "react";
import { useBkash } from "react-bkash";
import { publicRequest } from "../../api/apiLink";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import TdLoader from "../../components/common/TdLoader";

export default function BKashExecute() {
  const navigate = useNavigate();

  const payment = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return Object.fromEntries(urlParams.entries());
  }, []);

  const { loading, triggerBkash } = useBkash({
    onSuccess: () => (window.location.href = "/payment/success"),
    onClose: () => (window.location.href = "/"),
    bkashScriptURL:
      "https://scripts.pay.bka.sh/versions/1.2.0-beta/checkout/bKash-checkout.js",
    onCreatePayment: async () => {
      try {
        const billData = {
          amount: Number(payment.amount),
          merchantInvoiceNumber: Date.now(),
          intent: "sale",
          ispOwnerId: payment.ispOwner,
          billType: "bill",
          customer: payment?.customer,
          month: payment.month.split("_").join(", "),
          ...(payment?.reseller && {
            resellerId: payment?.reseller,
          }),
          user: payment?.user,
          billCollectedFrom: "app",
        };

        const response = await publicRequest.post(
          `bkash/createPublicPayment`,
          billData,
          {
            headers: {
              device: "mobile",
            },
          },
        );

        if (response.data?.statusCode === "0000") {
          window.location.href = response.data?.bkashURL;
        }
        return response.data;
      } catch (err) {
        toast.error(err.message);
        return null;
      }
    },
    onExecutePayment: async (paymentID) => {
      const response = await publicRequest.get(
        `bkash/payment/execute?paymentID=${paymentID}`,
        {
          headers: {
            device: "mobile",
          },
        },
      );

      if (response.data.success) {
        navigate("netfee://payment/successful");
      } else {
        navigate("netfee://payment/failed");
      }
    },
  });

  useEffect(() => {
    if (
      !loading &&
      payment.amount &&
      payment.month &&
      payment.customer &&
      payment.ispOwner
    ) {
      triggerBkash();
    }
  }, [loading, payment, triggerBkash]);

  return (
    <div className="d-flex justify-content-center align-items-center">
      <TdLoader />
    </div>
  );
}
